module.exports = __webpack_public_path__ + "img/plus.0c99586d.svg";